import { Dispatch } from 'redux';
import { ActionTypes, ReduxAction } from './types';
import {
  Auth,
  ClientconfigService,
  LoginService,
  RegistrierungService,
} from '../../api';
import { setNotification } from '../../utils/notificationUtils';
import { ERROR } from '../../layouts/notification/Notification';
import { AuthModel } from '../../models/AuthModel';
import jwtDecode from 'jwt-decode';
import { resetAuftragserfassung } from './auftragserfassung';

export const login =
  (nameOrMail: string, password: string) =>
  async (dispatch: Dispatch<ReduxAction>) => {
    if (!nameOrMail || !password) {
      setNotification('Bitte Benutzer und Passwort eingeben', [], ERROR, 10000);
    } else {
      const auth: Auth = { username: nameOrMail, password: password };
      new LoginService().login(auth).then(response => {
        dispatch({
          type: ActionTypes.SET_AUTHENTICATION,
          payload: response.data,
        });
        new ClientconfigService().getClientConfig().then(response => {
          dispatch({
            type: ActionTypes.SET_CLIENT_CONFIG,
            payload: response.data,
          });
        });
      });
    }
  };

export const changeLogin =
  (name: string) => async (dispatch: Dispatch<ReduxAction>) => {
    if (!name) {
      setNotification('Bitte Benutzer wählen', [], ERROR, 10000);
    } else {
      resetAuftragserfassung();
      const auth: AuthModel = { username: name };
      new LoginService().changelogin(auth).then(response => {
        const oldToken = localStorage.getItem('token');
        const oldUser = localStorage.getItem('username');
        if (oldToken && oldUser) {
          localStorage.setItem('backuptoken', oldToken);
          localStorage.setItem('backupUser', oldUser);
        }

        const newAuth: AuthModel = { ...response.data, backupToken: oldToken };
        dispatch({
          type: ActionTypes.SET_AUTHENTICATION,
          payload: newAuth,
        });
        dispatch({
          type: ActionTypes.RELOAD_USERMANAGEMENT,
          payload: newAuth,
        });
      });
    }
  };

export const revertSession = () => async (dispatch: Dispatch<ReduxAction>) => {
  const exToken = localStorage.getItem('backuptoken');
  const exUser = localStorage.getItem('backupUser');

  if (exToken && exUser) {
    localStorage.setItem('token', exToken);
    localStorage.setItem('username', exUser);
    localStorage.removeItem('backuptoken');
    localStorage.removeItem('backupUser');
    const decodedToken: any = jwtDecode(exToken);
    const mandantId = decodedToken['mandant-id'];
    resetAuftragserfassung();

    const auth: AuthModel = {
      accessToken: exToken,
      username: exUser,
      backupToken: undefined,
    };
    new LoginService().changelogin(auth).then(response => {
      dispatch({
        type: ActionTypes.SET_AUTHENTICATION,
        payload: response.data,
      });
      dispatch({
        type: ActionTypes.RELOAD_USERMANAGEMENT,
        payload: response.data,
      });
      dispatch({
        type: ActionTypes.SET_CURRENT_MANDANT_ID,
        payload: mandantId,
      });
    });
  }
};

export const logout =
  () =>
  (dispatch: Dispatch<ReduxAction>): void => {
    new LoginService().logout().then(response => {
      dispatch({
        type: ActionTypes.SET_AUTHENTICATION,
        payload: {},
      });
      dispatch({
        type: ActionTypes.RESET_CLIENT_CONFIG,
      });
    });
  };

export const confirmRegistry =
  (token: string) =>
  (dispatch: Dispatch<ReduxAction>): void => {
    if (token) {
      new RegistrierungService().confirmReg(token).then(response => {
        dispatch({
          type: ActionTypes.SET_CONFIRM_REGISTRY,
          payload: response.data,
        });
      });
    }
  };

export const getClientConfig =
  () =>
  (dispatch: Dispatch<ReduxAction>): void => {
    new ClientconfigService().getClientConfig().then(response => {
      dispatch({
        type: ActionTypes.SET_CLIENT_CONFIG,
        payload: response.data,
      });
    });
  };
